// extracted by mini-css-extract-plugin
export default {"imageWrapper":"A2APage_imageWrapper__eO0IL","fieldGroup":"A2APage_fieldGroup__xx+HK"};